module.exports = __webpack_public_path__ + "media/property-types/Estate-753ff2d6.png";